import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase";

/**
 * Fetch accreditation folders and files for a given user and root folder.
 * Returns an array of all files with their metadata.
 *
 * @param {string} userId - The user ID
 * @param {string} rootFolderId - The root folder ID under which accreditation_folder exists
 * @returns {Promise<Array>} - Array of file objects with metadata including classificationCategory
 */
export async function fetchAccreditationData(userId, rootFolderId) {
  if (!userId || !rootFolderId) {
    return [];
  }

  const basePath = `users/${userId}/folders/${rootFolderId}/accreditation_folder/main`;

  // Helper to fetch all files from a collection path
  async function fetchAllFiles(path) {
    try {
      const colRef = collection(db, path);
      const snapshot = await getDocs(colRef);
      // Filter out documents with id 'init'
      return snapshot.docs
        .filter((doc) => doc.id !== "init")
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
    } catch (error) {
      console.error("Error fetching files from", path, error);
      return [];
    }
  }

  // Fetch all files from single_page and multi_page collections
  const singlePagePath = `${basePath}/single_page`;
  const multiPagePath = `${basePath}/multi_page`;

  const [singleFiles, multiFiles] = await Promise.all([
    fetchAllFiles(singlePagePath),
    fetchAllFiles(multiPagePath),
  ]);

  // Combine all files
  const allFiles = [...singleFiles, ...multiFiles];

  return allFiles;
}
